module.exports = __webpack_public_path__ + "static/a-xx-172-art-6ecd76ea7296e27d60651ab2f4d14423.jpg";